import { render, staticRenderFns } from "./semester.vue?vue&type=template&id=0f8b68c0&scoped=true&"
import script from "./semester.vue?vue&type=script&lang=js&"
export * from "./semester.vue?vue&type=script&lang=js&"
import style0 from "./semester.vue?vue&type=style&index=0&id=0f8b68c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8b68c0",
  null
  
)

component.options.__file = "semester.vue"
export default component.exports